import { ref, watch } from "vue";
import i18n from "./../i18n.js";

export const currentLocale = i18n.global.locale;

watch(currentLocale, (newLocale) => {
  localStorage.setItem("language", newLocale);
});
